import axios from "axios";
import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { OcrType } from "../constant/enum";

interface OcrUploadRequest {
  token: string;
  file: File;
  type: OcrType;
  orgRoleId: number;
}

const ocrUpload = async ({
  token,
  file,
  type,
  orgRoleId,
}: OcrUploadRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.DOCUMENT_MANAGEMENT)}/document-management/ocr/upload`,
      { file, type, orgRoleId },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};
export default ocrUpload;
